import { getIndiceById } from '../pages/api'; // Ajuste o caminho conforme sua estrutura

// 1. Mapeamento centralizado dos IDs que a lógica de negócio utiliza
const INDICES_IDS = {
  TAXAS_ANUAIS: {
    1: '68b4d364333cea0aeca8a248',
    2: '68b4d373333cea0aeca8a24a',
    3: '68b4d390333cea0aeca8a24c',
    4: '68b4d39b333cea0aeca8a24e',
    5: '68b4d3ab333cea0aeca8a250',
  },
  MULTIPLICADORES_PARCELAS: {
    1: '68b4d3d6333cea0aeca8a252',
    2: '68b4d3e4333cea0aeca8a254',
    3: '68b4d3f3333cea0aeca8a256',
    4: '68b4d401333cea0aeca8a258',
  },
};

// 2. Cache para armazenar os valores dos índices após buscá-los no banco
const indicesCache = {};

// 3. Função para inicializar o cache.
// IMPORTANTE: Esta função deve ser chamada uma vez quando a aplicação carregar (ex: no App.js).
export async function inicializarIndicesSeguro() {
  try {
    const todosIds = [
      ...Object.values(INDICES_IDS.TAXAS_ANUAIS),
      ...Object.values(INDICES_IDS.MULTIPLICADORES_PARCELAS),
    ];

    // Busca todos os índices necessários em paralelo para melhor performance
    const promises = todosIds.map(id => getIndiceById(id).catch(() => null));
    const resultados = await Promise.all(promises);

    // Popula o cache com os resultados, usando o ID como chave e o valor como dado
    resultados.forEach(indice => {
      if (indice && indice._id) {
        indicesCache[indice._id] = indice.valor;
      }
    });

    return true;
  } catch (error) {
    console.error("Falha ao inicializar e popular o cache de índices do seguro:", error);
    return false;
  }
}


/**
 * Calcula o valor total do seguro e o valor de cada parcela usando os índices do cache.
 * @param {number} valorProjeto - O valor base do projeto.
 * @param {number} anos - A duração do seguro em anos (1 a 5).
 * @param {number} parcelas - O número de parcelas (1 a 4).
 * @returns {{valorTotal: number, valorParcela: number}} - Objeto com os valores calculados.
 */
export function calcularValoresSeguro(valorProjeto, anos, parcelas) {

  
  const idTaxaAnual = INDICES_IDS.TAXAS_ANUAIS[anos];
  const idMultiplicador = INDICES_IDS.MULTIPLICADORES_PARCELAS[parcelas];

  const taxaAnual = indicesCache[idTaxaAnual];
  const multiplicador = indicesCache[idMultiplicador];

  // Validação para garantir que os índices foram carregados no cache
  if (!valorProjeto || taxaAnual === undefined || multiplicador === undefined) {
    if (Object.keys(indicesCache).length === 0) {
        console.warn("Cálculo do seguro foi chamado antes da inicialização dos índices. Verifique se a função inicializarIndicesSeguro() foi executada.");
    }
    return { valorTotal: 0, valorParcela: 0 };
  }

  const premioBase = valorProjeto * taxaAnual;
  const valorTotal = premioBase * multiplicador;
  const valorParcela = valorTotal / parcelas;

  return { valorTotal, valorParcela };
}

// Função auxiliar para formatação de moeda (sem alterações)
export function formatarMoeda(valor) {
  return valor.toLocaleString('pt-BR', {
    style: 'currency',
    currency: 'BRL',
  });
}
